import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getTopPerformingAssetsBySales } from "../../assets/api/asset";
import AnimatedNumber from "../../common/components/AnimatedNumber";
import { toast } from "../../common/components/Toast";
import { SPACING } from "../../common/constants/spacing";

export const TopPerfomingContentBySales = () => {
  const { t } = useTranslation("analytics");
  const [assets, setAssets] = useState([]);

  useEffect(() => {
    const fetchTopPerformingAssets = async () => {
      try {
        const fetchedAssets = await getTopPerformingAssetsBySales();
        setAssets(fetchedAssets);
      } catch (error) {
        toast.error(error.message || "Failed to fetch analytics");
      }
    };

    fetchTopPerformingAssets();
  }, []);

  return (
    <Box>
      <Typography variant="h3" fontWeight="bold" sx={{ mt: 4, mb: SPACING.sm }}>
        {t("topPerformingContent.bySales")}
      </Typography>
      {!assets || assets.length === 0 ? (
        <Card sx={{ p: 3 }} variant="outlined">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              py: 4,
            }}
          >
            <Typography variant="bodyMd" sx={{ color: "text.secondary" }}>
              {t("topPerformingContent.noDataSales")}
            </Typography>
          </Box>
        </Card>
      ) : (
        <Card sx={{ p: 0, mb: 5 }} variant="outlined">
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight="bold">
                      Rank
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" fontWeight="bold">
                      Title
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography variant="subtitle2" fontWeight="bold">
                      Revenue
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {assets.map((asset, index) => (
                    <TableRow key={asset.id} hover>
                      <TableCell>
                        <Typography variant="bodySm" fontWeight="medium">
                          {index + 1}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="bodySm">{asset.title}</Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography variant="bodySm">
                          <AnimatedNumber
                            section="tables"
                            value={Number(asset.total_sales) || 0}
                            isCurrency
                          />
                        </Typography>
                      </TableCell>
                    </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      )}
    </Box>
  );
};
